export default "__VITE_ASSET__BEfsECB2__"